export default __webpack_public_path__ + "static/ecofuture_czarne-b3ad309bbb47dc4d8da4adc45d34472b.png";